export default {
  example_title: '示例',
  luoleAdmin_navigation: '招聘后台',
  luoleAdmin_menu_enterpriseList: '企业库',
  luoleAdmin_menu_enterpriseUsers: '企业用户',
  luoleAdmin_menu_enterpriseVerify: '企业认证',
  luoleAdmin_menu_talentManagement: '人才管理',
  luoleAdmin_menu_talentPool: '人才库',
  luoleAdmin_menu_resumePool: '简历库',
  luoleAdmin_menu_resumeLibrary: '简历库',
  luoleAdmin_menu_recruitmentManagement: '招聘管理',
  luoleAdmin_menu_jobManagement: '职位管理',
  luoleAdmin_menu_applicationManagement: '申请管理',
  luoleAdmin_menu_talentRecommendation: '人才推荐',
  luoleAdmin_menu_dictionary: '职位类别',
  luoleAdmin_menu_jobCategories: '职位类别',
  luoleAdmin_menu_resumeTemplateManagement: '简历模版',
  luoleAdmin_dashboard: '仪表板',
  luoleAdmin_menu_home: '首页',
  luoleAdmin_menu_chat: '聊天',
  luoleAdmin_menu_communication: '沟通',
  luoleAdmin_menu_jobApplication: '职位申请',
  luoleAdmin_userManagement: '用户管理',
  luoleAdmin_companyManagement: '企业管理',
  luoleAdmin_hunterManagement: '猎头管理',
  luoleAdmin_candidateManagement: '候选人管理',
  luoleAdmin_orderManagement: '订单管理',
  luoleAdmin_financeManagement: '财务管理',
  luoleAdmin_systemSettings: '系统设置',
  luoleAdmin_menu_rolePermissions: '角色权限',
  luoleAdmin_menu_members: '成员管理',
  luoleAdmin_reports: '报表统计',
  luoleAdmin_common_search: '搜索',
  luoleAdmin_common_filter: '筛选',
  luoleAdmin_common_export: '导出',
  luoleAdmin_common_import: '导入',
  luoleAdmin_common_refresh: '刷新',
  luoleAdmin_common_save: '保存',
  luoleAdmin_common_cancel: '取消',
  luoleAdmin_common_close: '关闭',
  luoleAdmin_common_empty: '暂无数据',
  luoleAdmin_common_confirm: '确认',
  luoleAdmin_common_delete: '删除',
  luoleAdmin_common_edit: '编辑',
  luoleAdmin_common_view: '查看',
  luoleAdmin_common_add: '添加',
  luoleAdmin_common_status: '状态',
  luoleAdmin_common_priority: '优先级',
  luoleAdmin_common_success: '成功',
  luoleAdmin_common_failed: '失败',
  luoleAdmin_common_must_be_image: '必须是图片文件',
  luoleAdmin_common_size_limit: '文件大小不能超过',
  luoleAdmin_common_date: '日期',
  luoleAdmin_common_actions: '操作',
  luoleAdmin_dashboard_error: '部分数据获取失败，已展示默认指标。',
  luoleAdmin_dashboard_error_title: '警告',
  luoleAdmin_dashboard_retry: '重试',
  luoleAdmin_dashboard_title: '数据概览',
  luoleAdmin_dashboard_subtitle: '实时监控招聘平台核心指标。',
  luoleAdmin_dashboard_card_enterprise: '企业总数',
  luoleAdmin_dashboard_card_talent: '人才总数',
  luoleAdmin_dashboard_card_job: '职位总数',
  luoleAdmin_dashboard_card_application: '投递总数',
  luoleAdmin_dashboard_label_active: '活跃',
  luoleAdmin_dashboard_label_verified: '认证',
  luoleAdmin_dashboard_label_resume: '简历完善度',
  luoleAdmin_dashboard_label_published: '已发布',
  luoleAdmin_dashboard_label_today: '今日',
  luoleAdmin_dashboard_label_week: '本周',
  luoleAdmin_dashboard_label_conversion: '转化率',
  luoleAdmin_dashboard_table_enterprise_name: '企业名称',
  luoleAdmin_dashboard_table_created_at: '创建时间',
  luoleAdmin_dashboard_table_candidate: '候选人',
  luoleAdmin_dashboard_table_job: '职位',
  luoleAdmin_dashboard_table_applied_at: '投递时间',
  luoleAdmin_dashboard_trend_title: '数据趋势（近30天）',
  luoleAdmin_dashboard_empty: '暂无数据',
  luoleAdmin_dashboard_enterprise_analysis: '企业分析',
  luoleAdmin_dashboard_status_distribution: '状态分布',
  luoleAdmin_dashboard_industry_distribution: '行业分布',
  luoleAdmin_dashboard_application_analysis: '投递分析',
  luoleAdmin_dashboard_conversion: '转化情况',
  luoleAdmin_dashboard_conversion_total: '整体转化率',
  luoleAdmin_dashboard_conversion_success: '成功率',
  luoleAdmin_dashboard_job_category: '职位分类分布',
  luoleAdmin_dashboard_job_location: '职位地域分布',
  luoleAdmin_dashboard_recent_enterprise: '最近企业',
  luoleAdmin_dashboard_recent_application: '最近投递',
  luoleAdmin_dashboard_status_active: '活跃',
  luoleAdmin_dashboard_status_inactive: '非活跃',
  luoleAdmin_dashboard_status_pending: '待激活',
  luoleAdmin_dashboard_application_applied: '已投递',
  luoleAdmin_dashboard_application_screening: '筛选中',
  luoleAdmin_dashboard_application_interviewing: '面试中',
  luoleAdmin_dashboard_application_offered: '已发 Offer',
  luoleAdmin_dashboard_application_accepted: '已接受',
  luoleAdmin_dashboard_application_rejected: '已拒绝',
  luoleAdmin_dashboard_chart_enterprise: '企业',
  luoleAdmin_dashboard_chart_talent: '人才',
  luoleAdmin_dashboard_chart_job: '职位',
  luoleAdmin_dashboard_chart_application: '投递',
  luoleAdmin_dashboard_go_ops: '查看运营看板',
  luoleAdmin_recruitmentOps_kpi_enterpriseTotal: '企业总数',
  luoleAdmin_recruitmentOps_kpi_publishedEnterprise: '已发布企业数',
  luoleAdmin_recruitmentOps_kpi_talentTotal: '人才总数',
  luoleAdmin_recruitmentOps_kpi_publishedJobs: '已发布职位数',
  luoleAdmin_recruitmentOps_kpi_jobPostingApplications: '职位申请总数',
  luoleAdmin_recruitmentOps_kpi_interviewTotal: '面试总数',
  luoleAdmin_recruitmentOps_kpi_offerTotal: 'Offer 总数',
  luoleAdmin_recruitmentOps_kpi_offerAcceptedTotal: 'Offer 接受数',
  luoleAdmin_recruitmentOps_filter_tenant: '选择企业（可按名称搜索）',
  luoleAdmin_recruitmentOps_filter_organization: '选择企业',
  luoleAdmin_recruitmentOps_filter_keyword: '关键词（职位/候选人/企业）',
  luoleAdmin_recruitmentOps_filter_status: '状态筛选',
  luoleAdmin_recruitmentOps_tab_jobs: '全部职位列表',
  luoleAdmin_recruitmentOps_tab_applications: '职位申请列表',
  luoleAdmin_recruitmentOps_jobs_title: '职位名称',
  luoleAdmin_recruitmentOps_jobs_company: '企业名称',
  luoleAdmin_recruitmentOps_jobs_publishedAt: '发布时间',
  luoleAdmin_recruitmentOps_jobs_applicationCount: '申请数',
  luoleAdmin_recruitmentOps_jobs_location: '工作地',
  luoleAdmin_recruitmentOps_jobs_recruiter: '创建人',
  luoleAdmin_recruitmentOps_backfill_button: '批量补全创建人',
  luoleAdmin_recruitmentOps_backfill_confirm_title: '确认批量补全创建人',
  luoleAdmin_recruitmentOps_backfill_confirm_content:
    '将按当前筛选范围（{{scope}}）补全职位创建人/更新人/归属人，是否继续？',
  luoleAdmin_recruitmentOps_backfill_scope_all: '全平台',
  luoleAdmin_recruitmentOps_backfill_success:
    '补全完成：更新职位 {{updatedJobTotal}} 条，涉及企业 {{updatedTenantTotal}} 个，跳过企业 {{skippedTenantTotal}} 个',
  luoleAdmin_recruitmentOps_app_candidate: '候选人',
  luoleAdmin_recruitmentOps_app_job: '职位',
  luoleAdmin_recruitmentOps_app_appliedDate: '申请时间',
  luoleAdmin_recruitmentOps_app_source: '来源',
  luoleAdmin_recruitmentOps_interview_modal_title: '面试明细',
  luoleAdmin_recruitmentOps_interview_candidate: '候选人',
  luoleAdmin_recruitmentOps_interview_job: '职位',
  luoleAdmin_recruitmentOps_interview_title: '面试标题',
  luoleAdmin_recruitmentOps_interview_time: '面试时间',
  luoleAdmin_enterpriseList_title: '企业列表',
  luoleAdmin_enterpriseList_subtitle: '管理企业账号信息、认证状态与联系人。',
  luoleAdmin_enterpriseList_search_placeholder: '搜索企业或联系人',
  luoleAdmin_enterpriseList_status_placeholder: '按状态筛选',
  luoleAdmin_enterpriseList_status_all: '全部状态',
  luoleAdmin_enterpriseList_status_active: '正常',
  luoleAdmin_enterpriseList_status_inactive: '停用',
  luoleAdmin_enterpriseList_status_pending: '待审核',
  luoleAdmin_enterpriseList_add: '添加企业',
  luoleAdmin_enterpriseList_batch_delete: '批量删除 ({{count}})',
  luoleAdmin_enterpriseList_load_failed: '企业列表获取失败。',
  luoleAdmin_enterpriseList_load_detail_failed: '获取企业详情失败。',
  luoleAdmin_enterpriseList_action_view: '查看详情',
  luoleAdmin_enterpriseList_action_downloadMiniProgramCode: '下载小程序码',
  luoleAdmin_enterpriseList_action_edit: '编辑',
  luoleAdmin_enterpriseList_action_delete: '删除',
  luoleAdmin_enterpriseList_downloadMiniProgramCode_success: '小程序码下载成功',
  luoleAdmin_enterpriseList_downloadMiniProgramCode_failed: '小程序码下载失败',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCode:
    '批量下载小程序码（Excel）',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCode_success:
    '批量下载成功',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCode_failed:
    '批量下载失败',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCodeZip:
    '批量下载图片包（ZIP）',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCodeZip_success:
    '图片包下载成功',
  luoleAdmin_enterpriseList_batch_downloadMiniProgramCodeZip_failed:
    '图片包下载失败',
  luoleAdmin_enterpriseList_delete_confirm: '确定要删除该企业吗？',
  luoleAdmin_enterpriseList_delete_success: '删除成功',
  luoleAdmin_enterpriseList_delete_failed: '删除失败',
  luoleAdmin_enterpriseList_update_success: '更新成功',
  luoleAdmin_enterpriseList_create_success: '创建成功',
  luoleAdmin_enterpriseList_save_failed: '保存失败',
  luoleAdmin_enterpriseList_batch_empty: '请先选择至少一个企业。',
  luoleAdmin_enterpriseList_missing_id: '缺少企业 ID。',
  luoleAdmin_enterpriseList_column_name: '企业名称',
  luoleAdmin_enterpriseList_column_industry: '所属行业',
  luoleAdmin_enterpriseList_column_scale: '企业规模',
  luoleAdmin_enterpriseList_column_contact: '联系人',
  luoleAdmin_enterpriseList_column_creator: '创建人',
  luoleAdmin_enterpriseList_column_creatorPhone: '创建人手机号',
  luoleAdmin_enterpriseList_column_certification: '认证状态',
  luoleAdmin_enterpriseList_certification_unverified: '未认证',
  luoleAdmin_enterpriseList_certification_pending: '待审核',
  luoleAdmin_enterpriseList_certification_verified: '已认证',
  luoleAdmin_enterpriseList_certification_rejected: '已驳回',
  luoleAdmin_enterpriseList_column_created: '创建时间',
  luoleAdmin_enterpriseList_pagination_total:
    '第 {start}-{end} 条 / 共 {total} 条',
  luoleAdmin_enterpriseList_modal_create: '新增企业',
  luoleAdmin_enterpriseList_modal_edit: '编辑企业',
  luoleAdmin_enterpriseList_form_required: '该字段为必填项。',
  luoleAdmin_enterpriseList_form_name: '企业名称',
  luoleAdmin_enterpriseList_form_name_placeholder: '请输入企业名称',
  luoleAdmin_enterpriseList_form_industry: '所属行业',
  luoleAdmin_enterpriseList_form_industry_placeholder: '请输入所属行业',
  luoleAdmin_enterpriseList_form_scale: '企业规模',
  luoleAdmin_enterpriseList_form_scale_placeholder: '请输入企业规模',
  luoleAdmin_enterpriseList_form_contact: '联系人',
  luoleAdmin_enterpriseList_form_contact_placeholder: '请输入联系人',
  luoleAdmin_enterpriseList_form_phone: '联系电话',
  luoleAdmin_enterpriseList_form_phone_placeholder: '请输入联系电话',
  luoleAdmin_enterpriseList_form_email: '邮箱',
  luoleAdmin_enterpriseList_form_email_placeholder: '请输入邮箱地址',
  luoleAdmin_enterpriseList_form_email_invalid: '请输入正确的邮箱格式。',
  luoleAdmin_enterpriseList_form_address: '企业地址',
  luoleAdmin_enterpriseList_form_address_placeholder: '请输入企业地址',
  luoleAdmin_enterpriseList_form_remark: '备注',
  luoleAdmin_enterpriseList_form_remark_placeholder: '请输入备注信息',
  luoleAdmin_enterpriseCreate_page_description: '填写下方企业信息以新增企业。',
  luoleAdmin_enterpriseCreate_page_description_edit: '在下方修改企业信息。',
  luoleAdmin_enterpriseDetail_load_failed: '加载企业详情失败。',
  luoleAdmin_enterpriseDetail_back: '返回列表',
  luoleAdmin_enterpriseDetail_edit: '编辑',
  luoleAdmin_enterpriseDetail_subtitle: '查看企业档案与联系方式。',
  luoleAdmin_enterpriseDetail_basic: '基本信息',
  luoleAdmin_enterpriseDetail_id: '企业ID',
  luoleAdmin_enterpriseDetail_created: '创建时间',
  luoleAdmin_enterpriseDetail_updated: '更新时间',
  luoleAdmin_enterpriseDetail_empty: '企业不存在或已被删除。',
  common_comingSoon: '功能迁移中，敬请期待。',
  luoleAdmin_enterpriseUsers_title: '企业用户',
  luoleAdmin_enterpriseUsers_description: '管理企业成员账号、角色与权限。',
  luoleAdmin_enterpriseUsers_stat_total: '会员总数',
  luoleAdmin_enterpriseUsers_stat_active: '活跃会员',
  luoleAdmin_enterpriseUsers_stat_pending: '待审核会员',
  luoleAdmin_enterpriseUsers_search_placeholder: '搜索姓名、邮箱或手机号',
  luoleAdmin_enterpriseUsers_status_placeholder: '按状态筛选',
  luoleAdmin_enterpriseUsers_status_suspended: '已锁定',
  luoleAdmin_enterpriseUsers_role_placeholder: '按角色筛选',
  luoleAdmin_enterpriseUsers_role_all: '全部角色',
  luoleAdmin_enterpriseUsers_load_failed: '加载企业用户失败。',
  luoleAdmin_enterpriseUsers_detail_failed: '获取用户详情失败。',
  luoleAdmin_enterpriseUsers_update_success: '用户更新成功。',
  luoleAdmin_enterpriseUsers_update_failed: '用户更新失败。',
  luoleAdmin_enterpriseUsers_delete_success: '删除成功。',
  luoleAdmin_enterpriseUsers_delete_failed: '删除失败。',
  luoleAdmin_enterpriseUsers_missing_id: '缺少用户 ID。',
  luoleAdmin_enterpriseUsers_action_view: '查看详情',
  luoleAdmin_enterpriseUsers_action_edit: '编辑',
  luoleAdmin_enterpriseUsers_action_delete: '删除',
  luoleAdmin_enterpriseUsers_action_activate: '激活',
  luoleAdmin_enterpriseUsers_action_deactivate: '停用',
  luoleAdmin_enterpriseUsers_action_lock: '锁定登录',
  luoleAdmin_enterpriseUsers_action_unlock: '解除锁定',
  luoleAdmin_enterpriseUsers_action_result_activate: '用户已激活',
  luoleAdmin_enterpriseUsers_action_result_deactivate: '用户已停用',
  luoleAdmin_enterpriseUsers_action_result_lock: '用户已锁定',
  luoleAdmin_enterpriseUsers_action_result_unlock: '用户已解除锁定',
  luoleAdmin_enterpriseUsers_delete_confirm: '确认删除该成员？',
  luoleAdmin_enterpriseUsers_batch_confirm: '确认删除选中的成员？',
  luoleAdmin_enterpriseUsers_batch_delete: '批量删除 ({{count}})',
  luoleAdmin_enterpriseUsers_batch_delete_success: '已删除 {{count}} 名成员。',
  luoleAdmin_enterpriseUsers_table_member: '成员信息',
  luoleAdmin_enterpriseUsers_table_contact: '联系方式',
  luoleAdmin_enterpriseUsers_table_company: '所属企业',
  luoleAdmin_enterpriseUsers_table_role: '角色',
  luoleAdmin_enterpriseUsers_table_lastLogin: '最近登录',
  luoleAdmin_enterpriseUsers_modal_title: '编辑成员',
  luoleAdmin_enterpriseUsers_form_role: '角色',
  luoleAdmin_enterpriseUsers_form_role_placeholder: '请选择角色',
  luoleAdmin_enterpriseUsers_form_role_required: '请选择角色',
  luoleAdmin_enterpriseUsers_form_status: '状态',
  luoleAdmin_enterpriseUsers_form_status_placeholder: '请选择状态',
  luoleAdmin_enterpriseUsers_form_status_required: '请选择状态',
  luoleAdmin_enterpriseUsers_form_position: '职位',
  luoleAdmin_enterpriseUsers_form_position_placeholder: '请输入职位',
  luoleAdmin_enterpriseUsers_form_employeeId: '工号',
  luoleAdmin_enterpriseUsers_form_employeeId_placeholder: '请输入工号',
  luoleAdmin_enterpriseUsers_detail_title: '成员详情',
  luoleAdmin_enterpriseUsers_detail_empty: '暂无详情数据。',
  luoleAdmin_enterpriseUsers_label_username: '用户名',
  luoleAdmin_enterpriseUsers_label_realName: '真实姓名',
  luoleAdmin_enterpriseUsers_label_email: '邮箱',
  luoleAdmin_enterpriseUsers_label_phone: '手机号',
  luoleAdmin_enterpriseUsers_label_role: '角色',
  luoleAdmin_enterpriseUsers_label_status: '状态',
  luoleAdmin_enterpriseUsers_label_enterprise: '所属企业',
  luoleAdmin_enterpriseUsers_label_position: '职位',
  luoleAdmin_enterpriseUsers_label_employeeId: '工号',
  luoleAdmin_enterpriseUsers_label_lastLogin: '最近登录',
  luoleAdmin_enterpriseUsers_label_created: '创建时间',
  luoleAdmin_enterpriseUsers_label_updated: '更新时间',
  luoleAdmin_enterpriseVerify_title: '企业认证',
  luoleAdmin_enterpriseVerify_description: '审核企业资质与认证申请。',
  luoleAdmin_enterpriseVerify_list_failed: '加载企业认证列表失败。',
  luoleAdmin_enterpriseVerify_review_approved: '已通过认证。',
  luoleAdmin_enterpriseVerify_review_rejected: '已拒绝该认证申请。',
  luoleAdmin_enterpriseVerify_review_failed: '更新审核状态失败。',
  luoleAdmin_enterpriseVerify_status_pending: '待审核',
  luoleAdmin_enterpriseVerify_status_pending_description:
    '已提交，等待平台审核',
  luoleAdmin_enterpriseVerify_status_unverified: '未提交',
  luoleAdmin_enterpriseVerify_status_unverified_description:
    '认证申请尚未正式提交',
  luoleAdmin_enterpriseVerify_status_approved: '已通过',
  luoleAdmin_enterpriseVerify_status_approved_description: '认证审核已完成',
  luoleAdmin_enterpriseVerify_status_rejected: '已拒绝',
  luoleAdmin_enterpriseVerify_status_rejected_description:
    '审核未通过，等待重新提交',
  luoleAdmin_enterpriseVerify_not_submitted: '尚未提交',
  luoleAdmin_enterpriseVerify_column_enterprise: '企业信息',
  luoleAdmin_enterpriseVerify_column_license: '营业执照',
  luoleAdmin_enterpriseVerify_column_remark: '备注',
  luoleAdmin_enterpriseVerify_column_email: '邮箱',
  luoleAdmin_enterpriseVerify_column_submittedAt: '提交时间',
  luoleAdmin_enterpriseVerify_column_reviewedAt: '审核时间',
  luoleAdmin_enterpriseVerify_column_status: '状态',
  luoleAdmin_enterpriseVerify_column_actions: '操作',
  luoleAdmin_enterpriseVerify_label_contact: '联系人：{{contact}} | {{phone}}',
  luoleAdmin_enterpriseVerify_action_view: '查看详情',
  luoleAdmin_enterpriseVerify_action_approve: '审核通过',
  luoleAdmin_enterpriseVerify_action_reject: '拒绝申请',
  luoleAdmin_enterpriseVerify_action_waiting_submit: '等待企业提交',
  luoleAdmin_enterpriseVerify_action_waiting_resubmit: '等待企业重新提交',
  luoleAdmin_enterpriseVerify_action_completed: '审核已完成',
  luoleAdmin_enterpriseVerify_stat_total: '认证申请',
  luoleAdmin_enterpriseVerify_stat_pending: '待审核',
  luoleAdmin_enterpriseVerify_stat_approved: '已通过',
  luoleAdmin_enterpriseVerify_search_placeholder: '搜索企业名称、联系人',
  luoleAdmin_enterpriseVerify_filter_all: '全部状态',
  luoleAdmin_enterpriseVerify_export_button: '导出列表',
  luoleAdmin_enterpriseVerify_detail_title: '企业认证详情',
  luoleAdmin_enterpriseVerify_step_submitted: '提交申请',
  luoleAdmin_enterpriseVerify_step_submitted_desc: '企业已提交认证资料',
  luoleAdmin_enterpriseVerify_step_reviewing: '审核中',
  luoleAdmin_enterpriseVerify_step_reviewing_desc: '管理员正在审核资料',
  luoleAdmin_enterpriseVerify_step_completed: '审核完成',
  luoleAdmin_enterpriseVerify_step_completed_desc: '认证通过或拒绝',
  luoleAdmin_enterpriseVerify_modal_title_approve: '确认通过审核',
  luoleAdmin_enterpriseVerify_modal_title_reject: '填写拒绝原因',
  luoleAdmin_enterpriseVerify_modal_desc_approve:
    '确认当前企业资料无误，允许通过认证？',
  luoleAdmin_enterpriseVerify_modal_desc_reject:
    '请填写拒绝原因，方便企业补充资料。',
  luoleAdmin_enterpriseVerify_modal_placeholder_reject: '请输入拒绝原因',
  luoleAdmin_institutionVerify_title: '高校认证审核',
  luoleAdmin_institutionVerify_description: '审核高校认证申请及认证材料。',
  luoleAdmin_institutionVerify_list_failed: '加载高校认证列表失败。',
  luoleAdmin_institutionVerify_access_denied_title: '暂无访问权限',
  luoleAdmin_institutionVerify_access_denied_description:
    '高校认证审核仅对平台管理员开放。',
  luoleAdmin_institutionVerify_back_home: '返回首页',
  luoleAdmin_institutionVerify_load_error_title: '高校认证列表加载失败',
  luoleAdmin_institutionVerify_load_error_description:
    '暂时无法获取高校认证数据，请稍后重试。',
  luoleAdmin_institutionVerify_reload: '重新加载',
  luoleAdmin_institutionVerify_status_all: '全部状态',
  luoleAdmin_institutionVerify_status_pending: '待审核',
  luoleAdmin_institutionVerify_status_verified: '已通过',
  luoleAdmin_institutionVerify_status_supplement: '待补充',
  luoleAdmin_institutionVerify_status_rejected: '已驳回',
  luoleAdmin_institutionVerify_status_draft: '草稿',
  luoleAdmin_institutionVerify_status_suspended: '已暂停',
  luoleAdmin_institutionVerify_status_expired: '已过期',
  luoleAdmin_institutionVerify_search_placeholder: '搜索学校、租户或申请人',
  luoleAdmin_institutionVerify_column_school: '学校 / 租户',
  luoleAdmin_institutionVerify_column_applicant: '申请人信息',
  luoleAdmin_institutionVerify_column_materials: '认证材料',
  luoleAdmin_institutionVerify_column_submittedAt: '提交时间',
  luoleAdmin_institutionVerify_column_reviewedAt: '审核时间',
  luoleAdmin_institutionVerify_column_reviewer: '审核人',
  luoleAdmin_institutionVerify_column_comment: '审核说明',
  luoleAdmin_institutionVerify_action_approve: '通过',
  luoleAdmin_institutionVerify_action_supplement: '要求补充',
  luoleAdmin_institutionVerify_action_reject: '驳回',
  luoleAdmin_institutionVerify_modal_approve_title: '审核通过',
  luoleAdmin_institutionVerify_modal_supplement_title: '要求补充材料',
  luoleAdmin_institutionVerify_modal_reject_title: '驳回高校认证',
  luoleAdmin_institutionVerify_modal_approve_placeholder:
    '可填写审核备注（选填）',
  luoleAdmin_institutionVerify_modal_supplement_placeholder:
    '请输入需要补充的材料或说明',
  luoleAdmin_institutionVerify_modal_reject_placeholder: '请输入驳回原因',
  luoleAdmin_institutionVerify_reason_required: '请填写原因。',
  luoleAdmin_institutionVerify_review_approve_success: '高校认证已通过。',
  luoleAdmin_institutionVerify_review_supplement_success: '已要求补充材料。',
  luoleAdmin_institutionVerify_review_reject_success: '高校认证已驳回。',
  luoleAdmin_institutionVerify_modal_delete_title: '删除高校认证',
  luoleAdmin_institutionVerify_modal_delete_content:
    '将删除「{school}」的认证申请和高校档案，删除后可重新提交认证。测试数据请确认后再删。',
  luoleAdmin_institutionVerify_delete_success: '高校认证已删除。',
  luoleAdmin_memberManagement_title: '会员管理',
  luoleAdmin_memberManagement_description: '维护平台会员档案与凭证。',
  luoleAdmin_memberManagement_load_failed: '加载会员数据失败。',
  luoleAdmin_memberManagement_update_success: '会员更新成功。',
  luoleAdmin_memberManagement_create_success: '会员创建成功。',
  luoleAdmin_memberManagement_save_failed: '保存失败，请重试。',
  luoleAdmin_memberManagement_delete_success: '删除成功。',
  luoleAdmin_memberManagement_delete_failed: '删除失败。',
  luoleAdmin_memberManagement_action_activate: '会员已激活。',
  luoleAdmin_memberManagement_action_deactivate: '会员已停用。',
  luoleAdmin_memberManagement_status_failed: '更新状态失败。',
  luoleAdmin_memberManagement_detail_failed: '获取会员详情失败。',
  luoleAdmin_memberManagement_stat_total: '会员总数',
  luoleAdmin_memberManagement_stat_active: '活跃会员',
  luoleAdmin_memberManagement_stat_inactive: '停用会员',
  luoleAdmin_memberManagement_search_placeholder: '搜索用户名、姓名或邮箱',
  luoleAdmin_memberManagement_filter_all: '全部状态',
  luoleAdmin_memberManagement_batch_placeholder: '批量操作即将支持。',
  luoleAdmin_memberManagement_batch_delete: '批量删除 ({{count}})',
  luoleAdmin_memberManagement_add_member: '添加会员',
  luoleAdmin_memberManagement_column_member: '会员信息',
  luoleAdmin_memberManagement_column_contact: '联系方式',
  luoleAdmin_memberManagement_column_role: '角色',
  luoleAdmin_memberManagement_column_registeredAt: '注册时间',
  luoleAdmin_memberManagement_action_view: '查看详情',
  luoleAdmin_memberManagement_action_edit: '编辑',
  luoleAdmin_memberManagement_action_delete: '删除',
  luoleAdmin_memberManagement_delete_confirm: '确定要删除该会员吗？',
  luoleAdmin_memberManagement_pagination_total:
    '第 {start}-{end} 条 / 共 {total} 条',
  luoleAdmin_memberManagement_modal_edit: '编辑会员',
  luoleAdmin_memberManagement_modal_create: '添加会员',
  luoleAdmin_memberManagement_form_username: '用户名',
  luoleAdmin_memberManagement_form_username_placeholder: '请输入用户名',
  luoleAdmin_memberManagement_form_realName: '真实姓名',
  luoleAdmin_memberManagement_form_realName_placeholder: '请输入真实姓名',
  luoleAdmin_memberManagement_form_email: '邮箱',
  luoleAdmin_memberManagement_form_email_placeholder: '请输入邮箱',
  luoleAdmin_memberManagement_form_email_invalid: '请输入正确的邮箱格式',
  luoleAdmin_memberManagement_form_phone: '手机号',
  luoleAdmin_memberManagement_form_phone_placeholder: '请输入手机号',
  luoleAdmin_memberManagement_form_phone_invalid: '请输入正确的手机号',
  luoleAdmin_memberManagement_form_role: '角色',
  luoleAdmin_memberManagement_form_role_placeholder: '请选择角色',
  luoleAdmin_memberManagement_form_status: '状态',
  luoleAdmin_memberManagement_form_status_placeholder: '请选择状态',
  luoleAdmin_memberManagement_form_required: '该字段为必填项。',
  luoleAdmin_memberManagement_role_member: '普通成员',
  luoleAdmin_memberManagement_role_manager: '部门经理',
  luoleAdmin_memberManagement_role_admin: '管理员',
  luoleAdmin_memberManagement_status_active: '正常',
  luoleAdmin_memberManagement_status_inactive: '停用',
  luoleAdmin_memberManagement_status_suspended: '已锁定',
  luoleAdmin_memberManagement_detail_title: '会员详情',
  luoleAdmin_memberManagement_detail_username: '用户名',
  luoleAdmin_memberManagement_detail_displayName: '显示名称',
  luoleAdmin_memberManagement_detail_phone: '手机号',
  luoleAdmin_memberManagement_detail_email: '邮箱',
  luoleAdmin_memberManagement_detail_role: '角色',
  luoleAdmin_memberManagement_detail_status: '状态',
  luoleAdmin_memberManagement_detail_employeeId: '工号',
  luoleAdmin_memberManagement_detail_position: '职位',
  luoleAdmin_memberManagement_detail_created: '创建时间',
  luoleAdmin_memberManagement_detail_joined: '加入时间',
  luoleAdmin_memberManagement_detail_bio: '个人简介',
  luoleAdmin_talentPool_search_placeholder:
    '搜职位/公司/行业等 (中文用空格隔开,英文用逗号隔开)',
  luoleAdmin_talentPool_search_include_all: '包含全部关键词',
  luoleAdmin_talentPool_search_include_any: '包含任意关键词',
  luoleAdmin_talentPool_filter_position: '职位',
  luoleAdmin_talentPool_filter_position_placeholder: '搜索职位',
  luoleAdmin_talentPool_filter_position_all: '全部职位',
  luoleAdmin_talentPool_filter_position_custom: '自定义职位',
  luoleAdmin_talentPool_filter_company: '公司',
  luoleAdmin_talentPool_filter_company_placeholder: '搜索公司',
  luoleAdmin_talentPool_filter_company_all: '全部公司',
  luoleAdmin_talentPool_filter_company_custom: '自定义公司',
  luoleAdmin_talentPool_filter_apply: '应用筛选',
  luoleAdmin_talentPool_less_conditions: '收起条件',
  luoleAdmin_talentPool_filter_currentCity: '目前城市',
  luoleAdmin_talentPool_filter_currentCity_no_limit: '不限',
  luoleAdmin_talentPool_filter_currentCity_other: '其他',
  luoleAdmin_talentPool_filter_expectedCity: '期望城市',
  luoleAdmin_talentPool_filter_expectedCity_no_limit: '不限',
  luoleAdmin_talentPool_filter_expectedCity_beijing: '北京',
  luoleAdmin_talentPool_filter_expectedCity_other: '其他',
  luoleAdmin_talentPool_filter_experience: '经验',
  luoleAdmin_talentPool_filter_experience_no_limit: '不限',
  luoleAdmin_talentPool_filter_experience_student: '在校/应届',
  luoleAdmin_talentPool_filter_experience_1_3: '1-3年',
  luoleAdmin_talentPool_filter_experience_3_5: '3-5年',
  luoleAdmin_talentPool_filter_experience_5_10: '5-10年',
  luoleAdmin_talentPool_filter_experience_custom: '自定义',
  luoleAdmin_talentPool_filter_education: '教育经历',
  luoleAdmin_talentPool_filter_education_no_limit: '不限',
  luoleAdmin_talentPool_filter_education_bachelor: '本科',
  luoleAdmin_talentPool_filter_education_master: '硕士',
  luoleAdmin_talentPool_filter_education_phd: '博士/博士后',
  luoleAdmin_talentPool_filter_education_college: '大专',
  luoleAdmin_talentPool_filter_education_vocational: '中专/中技',
  luoleAdmin_talentPool_filter_education_high_school: '高中及以下',
  luoleAdmin_talentPool_filter_other: '其他筛选',
  luoleAdmin_talentPool_filter_activeStatus: '活跃状态',
  luoleAdmin_talentPool_filter_jobStatus: '求职状态',
  luoleAdmin_talentPool_filter_jobHoppingFrequency: '跳槽频率',
  luoleAdmin_talentPool_filter_ageRequirement: '年龄要求',
  luoleAdmin_talentPool_filter_genderRequirement: '性别要求',
  luoleAdmin_talentPool_filter_languageRequirement: '语言要求',
  luoleAdmin_talentPool_filter_graduationYear: '毕业年份',
  luoleAdmin_talentPool_filter_currentIndustry: '当前行业',
  luoleAdmin_talentPool_filter_expectedIndustry: '期望行业',
  luoleAdmin_talentPool_filter_currentFunction: '当前职能',
  luoleAdmin_talentPool_filter_expectedFunction: '期望职能',
  luoleAdmin_talentPool_filter_currentSalary: '目前年薪',
  luoleAdmin_talentPool_filter_expectedSalary: '期望年薪',
  luoleAdmin_talentPool_filter_resumeLanguage: '简历语言',
  luoleAdmin_talentPool_filter_companyNature: '公司性质',
  luoleAdmin_talentPool_filter_managementExperience: '管理经验',
  luoleAdmin_talentPool_filter_overseasWork: '海外工作',
  luoleAdmin_talentPool_filter_graduationSchool: '毕业院校',
  luoleAdmin_talentPool_filter_graduationSchool_placeholder: '请输入毕业院校',
  luoleAdmin_talentPool_filter_major: '专业名称',
  luoleAdmin_talentPool_filter_major_placeholder: '请输入专业名称',
  luoleAdmin_talentPool_reset_conditions: '重置条件',
  luoleAdmin_talentPool_more_conditions: '更多条件',
  luoleAdmin_talentPool_empty_message: '请设置搜索条件进行搜索',
  luoleAdmin_talentPool_no_results: '未找到匹配的人才',
  luoleAdmin_talentPool_total_talents: '共找到 {{count}} 位人才',
  luoleAdmin_jobManagement_title: '职位管理',
  luoleAdmin_jobManagement_description: '发布与维护企业职位。',
  luoleAdmin_jobManagement_load_failed: '加载职位列表失败。',
  luoleAdmin_jobManagement_delete_success: '删除成功。',
  luoleAdmin_jobManagement_delete_failed: '删除失败。',
  luoleAdmin_jobManagement_batch_empty: '请先选择职位。',
  luoleAdmin_jobManagement_batch_delete_success: '已删除 {{count}} 个职位。',
  luoleAdmin_jobManagement_action_publish: '职位已发布。',
  luoleAdmin_jobManagement_action_close: '职位已关闭。',
  luoleAdmin_jobManagement_status_failed: '更新职位状态失败。',
  luoleAdmin_jobManagement_detail_failed: '获取职位详情失败。',
  luoleAdmin_jobManagement_update_success: '职位更新成功。',
  luoleAdmin_jobManagement_create_success: '职位创建成功。',
  luoleAdmin_jobManagement_save_failed: '保存职位失败。',
  luoleAdmin_jobManagement_salary_negotiable: '面议',
  luoleAdmin_jobManagement_column_job: '职位信息',
  luoleAdmin_jobManagement_column_salary: '薪资',
  luoleAdmin_jobManagement_column_type: '类型',
  luoleAdmin_jobManagement_column_status: '状态',
  luoleAdmin_jobManagement_column_metrics: '数据统计',
  luoleAdmin_jobManagement_column_publishDate: '发布时间',
  luoleAdmin_jobManagement_column_recruiter: '负责HR',
  luoleAdmin_jobManagement_metric_applications: '投递',
  luoleAdmin_jobManagement_metric_views: '浏览',
  luoleAdmin_jobManagement_action_view: '查看详情',
  luoleAdmin_jobManagement_action_edit: '编辑',
  luoleAdmin_jobManagement_action_delete: '删除',
  luoleAdmin_jobManagement_delete_confirm: '确定删除该职位？',
  luoleAdmin_jobManagement_batch_delete: '批量删除 ({{count}})',
  luoleAdmin_jobManagement_add_job: '发布职位',
  luoleAdmin_jobManagement_pagination_total:
    '第 {start}-{end} 条 / 共 {total} 条',
  luoleAdmin_jobManagement_detail_title: '职位详情',
  luoleAdmin_jobManagement_detail_description: '职位描述',
  luoleAdmin_jobManagement_detail_requirements: '任职要求',
  luoleAdmin_jobManagement_detail_responsibilities: '职位职责',
  luoleAdmin_jobPublish_title: '发布职位',
  luoleAdmin_jobPublish_description: '创建并发布新的职位信息',
  luoleAdmin_jobPublish_recruitment_type: '招聘类型',
  luoleAdmin_jobPublish_recruitment_type_required: '请选择招聘类型',
  luoleAdmin_jobPublish_recruitment_type_social: '社招职位',
  luoleAdmin_jobPublish_recruitment_type_fresh_graduate: '应届职位',
  luoleAdmin_jobPublish_recruitment_type_internship: '实习职位',
  luoleAdmin_jobPublish_recruitment_type_headhunting: '猎头服务',
  luoleAdmin_jobPublish_job_title: '职位名称',
  luoleAdmin_jobPublish_job_title_required: '请输入职位名称',
  luoleAdmin_jobPublish_job_title_placeholder:
    '请仔细填写职位名称,发布后不可修改',
  luoleAdmin_jobPublish_job_category: '职位类别',
  luoleAdmin_jobPublish_job_category_required: '请选择职位类别',
  luoleAdmin_jobPublish_job_category_placeholder: '请输入或选择职位类别',
  luoleAdmin_jobCategorySelector_title: '请选择职位类别',
  luoleAdmin_jobCategorySelector_search_placeholder: '请输入职位名称搜索',
  luoleAdmin_jobCategorySelector_feedback: '职位类别意见反馈',
  luoleAdmin_jobCategorySelector_select_first_level: '请从左侧选择类别',
  luoleAdmin_jobCategorySelector_no_results: '暂无匹配结果',
  luoleAdmin_jobPublish_job_description: '职位描述',
  luoleAdmin_jobPublish_job_description_required: '请输入职位描述',
  luoleAdmin_jobPublish_job_description_placeholder: '职责描述:\n任职要求:',
  luoleAdmin_jobPublish_ai_write: 'AI帮写',
  luoleAdmin_jobPublish_ai_write_hint: '不太清楚怎么写JD?快试试AI帮写吧~',
  luoleAdmin_jobPublish_ai_write_coming_soon: 'AI帮写功能即将上线',
  luoleAdmin_jobPublish_ai_writing: 'AI正在生成职位描述，请稍候...',
  luoleAdmin_jobPublish_ai_write_success: '职位描述生成成功',
  luoleAdmin_jobPublish_ai_write_failed: '职位描述生成失败，请稍后重试',
  luoleAdmin_jobPublish_view_examples: '看看别人怎么写',
  luoleAdmin_jobPublish_view_examples_coming_soon: '示例功能即将上线',
  luoleAdmin_jobPublish_description_warning: '职位描述中请勿填写涉及歧视的内容',
  luoleAdmin_jobPublish_use_template: '使用模版/草稿',
  luoleAdmin_jobPublish_job_requirements: '职位要求',
  luoleAdmin_jobPublish_job_requirements_placeholder:
    '请输入职位要求，支持AI帮写',
  luoleAdmin_jobPublish_ai_write_requirements_hint:
    'AI将根据职位信息自动生成职位要求',
  luoleAdmin_jobPublish_ai_writing_requirements:
    'AI正在生成职位要求，请稍候...',
  luoleAdmin_jobPublish_ai_write_requirements_success: '职位要求生成成功',
  luoleAdmin_jobPublish_ai_write_requirements_failed:
    '职位要求生成失败，请稍后重试',
  luoleAdmin_jobPublish_work_experience: '工作经验',
  luoleAdmin_jobPublish_work_experience_required: '请选择工作经验要求',
  luoleAdmin_jobPublish_work_experience_placeholder: '工作经验要求',
  luoleAdmin_jobPublish_experience_no_limit: '不限',
  luoleAdmin_jobPublish_experience_1_year: '1年',
  luoleAdmin_jobPublish_experience_2_years: '2年',
  luoleAdmin_jobPublish_experience_3_years: '3年',
  luoleAdmin_jobPublish_experience_5_years: '5年',
  luoleAdmin_jobPublish_experience_10_years: '10年以上',
  luoleAdmin_jobPublish_allow_students: '允许学生投递',
  luoleAdmin_jobPublish_education_level: '学历要求',
  luoleAdmin_jobPublish_education_level_required: '请选择学历要求',
  luoleAdmin_jobPublish_education_level_placeholder: '最低学历要求',
  luoleAdmin_jobPublish_education_no_limit: '不限',
  luoleAdmin_jobPublish_education_college: '专科',
  luoleAdmin_jobPublish_education_bachelor: '本科',
  luoleAdmin_jobPublish_education_master: '硕士',
  luoleAdmin_jobPublish_education_doctor: '博士',
  luoleAdmin_jobPublish_unified_recruitment: '统招',
  luoleAdmin_jobPublish_salary_range: '薪资范围',
  luoleAdmin_jobPublish_salary_range_required: '请选择薪资范围',
  luoleAdmin_jobPublish_salary_max_less_than_min: '最高薪资必须大于最低薪资',
  luoleAdmin_jobPublish_salary_min: '最低月薪',
  luoleAdmin_jobPublish_salary_max: '最高月薪',
  luoleAdmin_jobPublish_salary_months_12: '12个月',
  luoleAdmin_jobPublish_salary_months_13: '13个月',
  luoleAdmin_jobPublish_salary_months_14: '14个月',
  luoleAdmin_jobPublish_salary_negotiable: '面议',
  luoleAdmin_jobPublish_benefits: '职位福利',
  luoleAdmin_jobPublish_add_benefit: '添加福利',
  luoleAdmin_jobPublish_add_benefit_prompt: '请输入福利名称',
  luoleAdmin_jobPublish_language_requirements: '语言要求',
  luoleAdmin_jobPublish_language_mandarin: '普通话',
  luoleAdmin_jobPublish_language_english: '英语',
  luoleAdmin_jobPublish_language_cantonese: '粤语',
  luoleAdmin_jobPublish_language_french: '法语',
  luoleAdmin_jobPublish_language_japanese: '日语',
  luoleAdmin_jobPublish_language_other: '其他',
  luoleAdmin_jobPublish_overseas_experience: '海外经历',
  luoleAdmin_jobPublish_overseas_work_experience: '海外工作经历',
  luoleAdmin_jobPublish_overseas_education_background: '海外教育背景',
  luoleAdmin_jobPublish_work_location: '工作地址',
  luoleAdmin_jobPublish_work_location_required: '请选择工作地址',
  luoleAdmin_jobPublish_work_location_placeholder:
    '请仔细选择城市,发布后不可修改',
  luoleAdmin_jobPublish_map_select: '地图选点',
  luoleAdmin_jobPublish_map_select_location: '选择位置',
  luoleAdmin_jobPublish_map_select_prompt:
    '请在地图上选择位置，然后复制地址到输入框中',
  luoleAdmin_jobPublish_map_select_failed: '无法打开地图，请重试或手动输入地址',
  luoleAdmin_mapLocationPicker_title: '地图选点',
  luoleAdmin_mapLocationPicker_search_placeholder: '搜索地点或地址',
  luoleAdmin_mapLocationPicker_loading: '地图加载中...',
  luoleAdmin_mapLocationPicker_selected_address: '已选地址',
  luoleAdmin_mapLocationPicker_tip_click: '点击地图选择位置',
  luoleAdmin_mapLocationPicker_tip_drag: '可以拖动标记调整位置',
  luoleAdmin_mapLocationPicker_geocode_failed: '获取地址失败',
  luoleAdmin_mapLocationPicker_search_not_found:
    '未找到该地点，请尝试其他关键词',
  luoleAdmin_mapLocationPicker_select_first: '请先在地图上选择位置',
  luoleAdmin_mapLocationPicker_select_success: '位置选择成功',
  luoleAdmin_mapLocationPicker_load_failed: '地图脚本加载失败，请检查网络连接',
  luoleAdmin_mapLocationPicker_init_failed: '地图初始化失败，请重试',
  luoleAdmin_mapLocationPicker_config_invalid:
    '高德地图 API Key 未配置或无效，请检查配置文件',
  luoleAdmin_mapLocationPicker_api_key_invalid:
    '高德地图 API Key 无效，请检查配置文件 src/web/config/amap.ts',
  luoleAdmin_jobPublish_industry_requirements: '行业要求',
  luoleAdmin_jobPublish_industry_requirements_required: '请选择行业',
  luoleAdmin_jobPublish_all_industries: '全部行业',
  luoleAdmin_jobPublish_add_industry: '添加行业',
  luoleAdmin_jobPublish_add_industry_prompt: '请输入行业名称',
  luoleAdmin_jobPublish_industry_already_exists: '该行业已存在',
  luoleAdmin_jobPublish_submit: '发布',
  luoleAdmin_jobPublish_create_success: '职位发布成功',
  luoleAdmin_jobPublish_create_failed: '职位发布失败',
  luoleAdmin_jobPublish_load_template_failed: '加载模板失败',
  luoleAdmin_jobPublish_load_enterprises_failed: '加载企业列表失败',
  luoleAdmin_jobPublish_proxy_enterprise: '代发企业',
  luoleAdmin_jobPublish_proxy_enterprise_placeholder: '请选择代发企业',
  luoleAdmin_jobPublish_publish_to: '发布到',
  luoleAdmin_jobPublish_publish_to_placeholder: '请选择发布平台',
  luoleAdmin_jobPublish_publish_to_internal: '内部平台',
  luoleAdmin_jobPublish_publish_to_external: '外部平台',
  luoleAdmin_jobPublish_publish_to_boss: 'Boss直聘',
  luoleAdmin_jobPublish_job_fair: '关联招聘会',
  luoleAdmin_jobPublish_job_fair_placeholder: '请选择关联的招聘会（可选）',
  luoleAdmin_jobPublish_publish_to_zhilian: '智联招聘',
  luoleAdmin_jobPublish_publish_to_liepin: '猎聘',
  luoleAdmin_jobPublish_title_edit: '编辑职位',
  luoleAdmin_jobPublish_description_edit: '编辑职位信息，修改后点击提交保存',
  luoleAdmin_jobPublish_update_success: '职位更新成功',
  luoleAdmin_jobPublish_update_failed: '职位更新失败',
  luoleAdmin_jobPublish_load_job_failed: '加载职位详情失败',
  luoleAdmin_jobPublish_recruiter: '负责HR',
  luoleAdmin_jobPublish_recruiter_required: '请选择负责HR',
  luoleAdmin_jobPublish_recruiter_placeholder: '请选择负责HR',
  luoleAdmin_jobPublish_load_hrs_failed: '加载HR列表失败',
  luoleAdmin_jobPublish_no_hr_available: '该企业暂无可用HR',
  luoleAdmin_common_back: '返回',
  luoleAdmin_jobManagement_modal_edit: '编辑职位',
  luoleAdmin_jobManagement_modal_create: '发布职位',
  luoleAdmin_jobManagement_form_title: '职位名称',
  luoleAdmin_jobManagement_form_title_placeholder: '请输入职位名称',
  luoleAdmin_jobManagement_form_location: '工作地点',
  luoleAdmin_jobManagement_form_location_placeholder: '请输入工作地点',
  luoleAdmin_jobManagement_form_type: '职位类型',
  luoleAdmin_jobManagement_form_type_placeholder: '请选择职位类型',
  luoleAdmin_jobManagement_form_category: '职位类别',
  luoleAdmin_jobManagement_form_category_placeholder: '请选择职位类别',
  luoleAdmin_jobManagement_form_salary: '薪资范围',
  luoleAdmin_jobManagement_form_salary_min: '最低',
  luoleAdmin_jobManagement_form_salary_max: '最高',
  luoleAdmin_jobManagement_form_headcount: '招聘人数',
  luoleAdmin_jobManagement_form_education: '最低学历',
  luoleAdmin_jobManagement_form_education_placeholder: '请输入学历要求',
  luoleAdmin_jobManagement_form_experience: '经验要求',
  luoleAdmin_jobManagement_form_experience_placeholder: '请输入经验要求',
  luoleAdmin_jobManagement_form_description: '职位描述',
  luoleAdmin_jobManagement_form_description_placeholder: '请输入职位描述',
  luoleAdmin_jobManagement_form_requirements: '任职要求',
  luoleAdmin_jobManagement_form_requirements_placeholder: '请输入任职要求',
  luoleAdmin_jobManagement_form_benefits: '福利待遇',
  luoleAdmin_jobManagement_form_benefits_placeholder:
    '请输入福利待遇或补充说明',
  luoleAdmin_jobManagement_form_expireDate: '申请截止日期',
  luoleAdmin_jobManagement_form_expireDate_placeholder: '如：2024-12-31',
  luoleAdmin_jobManagement_form_required: '该字段为必填项。',
  luoleAdmin_jobManagement_createChoice_title: '选择创建方式',
  luoleAdmin_jobManagement_createChoice_fromBlank: '从空白创建',
  luoleAdmin_jobManagement_createChoice_fromBlank_desc: '创建全新的职位信息',
  luoleAdmin_jobManagement_createChoice_fromTemplate: '基于已发布职位创建',
  luoleAdmin_jobManagement_createChoice_fromTemplate_desc:
    '选择已有的已发布职位作为模板快速创建',
  luoleAdmin_jobManagement_templateList_title: '选择已发布职位作为模板',
  luoleAdmin_jobManagement_templateList_use: '使用此模板',
  luoleAdmin_jobManagement_message_load_published_failed: '加载已发布职位失败',
  luoleAdmin_jobManagement_status_active: '招聘中',
  luoleAdmin_jobManagement_status_inactive: '草稿',
  luoleAdmin_jobManagement_status_closed: '已关闭',
  luoleAdmin_jobManagement_status_archived: '已归档',
  luoleAdmin_jobManagement_status_unknown: '未知',
  luoleAdmin_jobManagement_type_fullTime: '全职',
  luoleAdmin_jobManagement_type_partTime: '兼职',
  luoleAdmin_jobManagement_type_contract: '合同',
  luoleAdmin_jobManagement_type_internship: '实习',
  luoleAdmin_jobManagement_type_other: '其他',
  luoleAdmin_jobManagement_unknown_company: '未知公司',
  luoleAdmin_jobManagement_unknown_location: '地点待定',
  luoleAdmin_jobManagement_filter_status_all: '全部状态',
  luoleAdmin_jobManagement_filter_category_all: '全部类别',
  luoleAdmin_jobManagement_tab_all: '全部',
  luoleAdmin_jobManagement_tab_active: '招聘中',
  luoleAdmin_jobManagement_tab_pending: '待发布',
  luoleAdmin_jobManagement_tab_closed: '已关闭',
  luoleAdmin_jobManagement_tab_draft: '草稿',
  luoleAdmin_jobManagement_search_placeholder: '搜索职位名称或公司',
  luoleAdmin_jobManagement_stat_total: '总职位数',
  luoleAdmin_jobManagement_stat_active: '招聘中',
  luoleAdmin_jobManagement_stat_draft: '草稿',
  luoleAdmin_jobManagement_stat_applications: '投递总数',
  luoleAdmin_jobPending_title: '待审核职位',
  luoleAdmin_jobPending_description: '处理待审核的职位发布。',
  luoleAdmin_resumeManagement_title: '简历管理',
  luoleAdmin_resumeManagement_description: '管理平台所有候选人简历信息',
  luoleAdmin_resumeManagement_search_placeholder: '搜索候选人/职位',
  luoleAdmin_resumeManagement_status_placeholder: '全部状态',
  luoleAdmin_resumeManagement_status_all: '全部状态',
  luoleAdmin_resumeManagement_status_active: '活跃',
  luoleAdmin_resumeManagement_status_inactive: '停用',
  luoleAdmin_resumeManagement_status_archived: '归档',
  luoleAdmin_resumeManagement_experience_placeholder: '全部经验',
  luoleAdmin_resumeManagement_experience_all: '全部经验',
  luoleAdmin_resumeManagement_experience_junior: '0-3年',
  luoleAdmin_resumeManagement_experience_mid: '3-7年',
  luoleAdmin_resumeManagement_experience_senior: '7年以上',
  luoleAdmin_resumeManagement_stat_total: '总简历数',
  luoleAdmin_resumeManagement_stat_active: '活跃简历',
  luoleAdmin_resumeManagement_stat_avgCompleteness: '平均完整度',
  luoleAdmin_resumeManagement_stat_viewsDownloads: '总浏览/下载',
  luoleAdmin_resumeManagement_action_export: '导出列表',
  luoleAdmin_resumeManagement_action_batch: '批量操作',
  luoleAdmin_resumeManagement_table_candidate: '候选人信息',
  luoleAdmin_resumeManagement_table_title: '简历标题',
  luoleAdmin_resumeManagement_table_experience: '经验/学历',
  luoleAdmin_resumeManagement_table_skills: '技能标签',
  luoleAdmin_resumeManagement_table_completeness: '完整度',
  luoleAdmin_resumeManagement_table_rating: '评分',
  luoleAdmin_resumeManagement_table_status: '状态',
  luoleAdmin_resumeManagement_table_stats: '数据统计',
  luoleAdmin_resumeManagement_table_lastUpdate: '最后更新',
  luoleAdmin_resumeManagement_table_actions: '操作',
  luoleAdmin_resumeManagement_action_view: '查看详情',
  luoleAdmin_resumeManagement_action_download: '下载简历',
  luoleAdmin_resumeManagement_detail_title: '简历详情',
  luoleAdmin_resumeManagement_detail_candidate: '候选人',
  luoleAdmin_resumeManagement_detail_position: '意向职位',
  luoleAdmin_resumeManagement_detail_phone: '联系电话',
  luoleAdmin_resumeManagement_detail_email: '邮箱',
  luoleAdmin_resumeManagement_detail_location: '期望城市',
  luoleAdmin_resumeManagement_detail_salary: '期望薪资',
  luoleAdmin_resumeManagement_detail_skills: '技能特长',
  luoleAdmin_resumeManagement_detail_selfEvaluation: '自我评价',
  luoleAdmin_resumeManagement_message_load_failed: '加载简历列表失败',
  luoleAdmin_resumeManagement_message_load_detail_failed: '加载简历详情失败',
  luoleAdmin_resumeManagement_message_no_attachment: '该简历暂无附件',
  luoleAdmin_resumeManagement_unknown_candidate: '未命名候选人',
  luoleAdmin_resumeManagement_unknown_title: '未填写职位',
  luoleAdmin_resumeManagement_unknown_status: '未知',
  luoleAdmin_resumeLibrary_title: '简历库',
  luoleAdmin_resumeLibrary_all_favorites: '全部简历',
  luoleAdmin_resumeLibrary_manage: '管理',
  luoleAdmin_resumeLibrary_load_failed: '加载简历列表失败',
  luoleAdmin_resumeLibrary_load_groups_failed: '加载分组列表失败',
  luoleAdmin_resumeLibrary_empty: '暂无数据',
  luoleAdmin_resumeLibrary_select_first: '请先选择简历',
  luoleAdmin_resumeLibrary_batch_unfavorite: '取消收藏',
  luoleAdmin_resumeLibrary_batch_remove_from_group: '从分组移除',
  luoleAdmin_resumeLibrary_batch_view: '批量浏览简历',
  luoleAdmin_resumeLibrary_forward: '转发给同事',
  luoleAdmin_resumeLibrary_view_resume: '查看简历：{{name}}',
  luoleAdmin_resumeLibrary_search_resume_id: '简历编号',
  luoleAdmin_resumeLibrary_search_name: '姓名',
  luoleAdmin_resumeLibrary_search_position: '目前任职',
  luoleAdmin_resumeLibrary_search_company: '目前公司',
  luoleAdmin_resumeLibrary_column_name: '姓名',
  luoleAdmin_resumeLibrary_column_gender: '性别',
  luoleAdmin_resumeLibrary_column_age: '年龄',
  luoleAdmin_resumeLibrary_column_education: '学历',
  luoleAdmin_resumeLibrary_column_position: '目前职位',
  luoleAdmin_resumeLibrary_column_company: '目前公司',
  luoleAdmin_resumeLibrary_column_collected_time: '加入时间',
  luoleAdmin_resumeLibrary_pagination: '共{total}份简历,分{{pages}}页显示',
  luoleAdmin_applicationManagement_title: '申请记录管理',
  luoleAdmin_applicationManagement_description:
    '管理职位申请记录，支持查看、筛选、搜索和分页',
  luoleAdmin_applicationManagement_search_placeholder: '搜索候选人或职位',
  luoleAdmin_applicationManagement_status_placeholder: '按状态筛选',
  luoleAdmin_applicationManagement_status_all: '全部状态',
  luoleAdmin_applicationManagement_status_applied: '已投递',
  luoleAdmin_applicationManagement_status_screening: '筛选中',
  luoleAdmin_applicationManagement_status_interviewing: '面试中',
  luoleAdmin_applicationManagement_status_offered: '已发 Offer',
  luoleAdmin_applicationManagement_status_accepted: '已录用',
  luoleAdmin_applicationManagement_status_rejected: '已拒绝',
  luoleAdmin_applicationManagement_status_withdrawn: '已撤回',
  luoleAdmin_applicationManagement_card_total: '投递总数',
  luoleAdmin_applicationManagement_card_total_desc: '系统中记录的全部投递。',
  luoleAdmin_applicationManagement_card_screening: '筛选中',
  luoleAdmin_applicationManagement_card_screening_desc:
    '当前处于筛选阶段的申请。',
  luoleAdmin_applicationManagement_card_interviewing: '面试中',
  luoleAdmin_applicationManagement_card_interviewing_desc:
    '已安排面试的候选人。',
  luoleAdmin_applicationManagement_card_accepted: '已录用',
  luoleAdmin_applicationManagement_card_accepted_desc:
    '企业已确认录用的候选人。',
  luoleAdmin_applicationManagement_action_batch: '批量操作',
  luoleAdmin_applicationManagement_table_candidate: '候选人信息',
  luoleAdmin_applicationManagement_table_job: '投递职位',
  luoleAdmin_applicationManagement_table_applyTime: '投递时间',
  luoleAdmin_applicationManagement_table_status: '当前状态',
  luoleAdmin_applicationManagement_table_notes: '备注',
  luoleAdmin_applicationManagement_table_notes_empty: '暂无备注',
  luoleAdmin_applicationManagement_table_lastUpdate: '最后更新',
  luoleAdmin_applicationManagement_table_actions: '操作',
  luoleAdmin_applicationManagement_action_view: '查看详情',
  luoleAdmin_applicationManagement_action_screening: '进入筛选',
  luoleAdmin_applicationManagement_action_interviewing: '安排面试',
  luoleAdmin_applicationManagement_action_offered: '发出 Offer',
  luoleAdmin_applicationManagement_action_rejected: '标记拒绝',
  luoleAdmin_applicationManagement_action_accepted: '标记录用',
  luoleAdmin_applicationManagement_message_load_failed: '加载投递列表失败。',
  luoleAdmin_applicationManagement_message_updating: '状态更新中…',
  luoleAdmin_applicationManagement_message_update_success: '状态更新成功。',
  luoleAdmin_applicationManagement_message_update_failed: '状态更新失败。',
  luoleAdmin_applicationManagement_message_resume_failed: '简历详情加载失败。',
  luoleAdmin_applicationManagement_pagination_total:
    '第 {start}-{end} 条 / 共 {total} 条',
  luoleAdmin_applicationManagement_detail_title: '投递详情',
  luoleAdmin_applicationManagement_detail_candidate: '候选人',
  luoleAdmin_applicationManagement_detail_job: '职位',
  luoleAdmin_applicationManagement_detail_status: '当前状态',
  luoleAdmin_applicationManagement_detail_timeline: '时间线',
  luoleAdmin_applicationManagement_detail_submitted: '提交',
  luoleAdmin_applicationManagement_detail_updated: '更新',
  luoleAdmin_applicationManagement_detail_notes: '备注',
  luoleAdmin_applicationManagement_detail_notes_empty: '暂无备注信息。',
  luoleAdmin_applicationManagement_detail_steps: '状态进度',
  luoleAdmin_applicationManagement_detail_resume: '简历摘要',
  luoleAdmin_applicationManagement_detail_resume_empty: '暂无简历详情。',
  luoleAdmin_applicationManagement_detail_empty: '请选择一条投递记录查看详情。',
  luoleAdmin_applicationManagement_resume_title: '目标职位',
  luoleAdmin_applicationManagement_resume_experience: '工作经验',
  luoleAdmin_applicationManagement_resume_skills: '技能标签',
  luoleAdmin_applicationManagement_table_screening_score: '筛选评分',
  luoleAdmin_applicationManagement_table_cover_letter: '求职信',
  luoleAdmin_applicationManagement_table_resume: '简历',
  luoleAdmin_applicationManagement_table_updated_at: '更新时间',
  luoleAdmin_applicationManagement_action_create: '新建申请记录',
  luoleAdmin_applicationManagement_action_edit: '编辑',
  luoleAdmin_applicationManagement_action_delete: '删除',
  luoleAdmin_applicationManagement_action_pass_screening: '通过筛选',
  luoleAdmin_applicationManagement_action_schedule_interview: '安排面试',
  luoleAdmin_applicationManagement_action_send_offer: '发送Offer',
  luoleAdmin_applicationManagement_action_reject: '拒绝',
  luoleAdmin_applicationManagement_batch_update_status: '批量更新状态',
  luoleAdmin_applicationManagement_company_not_set: '未设置企业',
  luoleAdmin_applicationManagement_resume_view: '查看简历',
  luoleAdmin_applicationManagement_resume_view_coming_soon:
    '简历查看功能即将上线',
  luoleAdmin_applicationManagement_detail_coming_soon: '详情查看功能即将上线',
  luoleAdmin_applicationManagement_edit_coming_soon: '编辑功能即将上线',
  luoleAdmin_applicationManagement_create_coming_soon: '新建功能即将上线',
  luoleAdmin_applicationManagement_confirm_delete: '确认删除',
  luoleAdmin_applicationManagement_confirm_delete_description:
    '确定要删除这条申请记录吗？此操作不可恢复。',
  luoleAdmin_applicationManagement_message_delete_success: '删除成功',
  luoleAdmin_applicationManagement_message_delete_failed: '删除失败',
  luoleAdmin_applicationManagement_message_select_first: '请先选择记录',
  luoleAdmin_applicationManagement_message_batch_update_success: '批量更新成功',
  luoleAdmin_applicationManagement_message_batch_update_failed: '批量更新失败',
  luoleAdmin_applicationManagement_pagination_page: '第',
  luoleAdmin_applicationManagement_pagination_of: '共',
  luoleAdmin_applicationManagement_pagination_items: '条',
  luoleAdmin_jobFairManagement_title: '招聘会',
  luoleAdmin_jobFairManagement_description: '配置与监控招聘会活动。',
  luoleAdmin_menu_jobFairManagement: '招聘会',
  luoleAdmin_jobFair_search_placeholder: '按名称或描述搜索',
  luoleAdmin_jobFair_status_placeholder: '按状态筛选',
  luoleAdmin_jobFair_status_all: '全部状态',
  luoleAdmin_jobFair_status_draft: '草稿',
  luoleAdmin_jobFair_status_upcoming: '即将开始',
  luoleAdmin_jobFair_status_ongoing: '进行中',
  luoleAdmin_jobFair_status_completed: '已结束',
  luoleAdmin_jobFair_status_cancelled: '已取消',
  luoleAdmin_jobFair_add: '创建招聘会',
  luoleAdmin_jobFair_batch_delete: '批量删除（{{count}}）',
  luoleAdmin_jobFair_load_failed: '加载招聘会列表失败。',
  luoleAdmin_jobFair_action_view: '查看详情',
  luoleAdmin_jobFair_action_edit: '编辑',
  luoleAdmin_jobFair_action_delete: '删除',
  luoleAdmin_jobFair_action_copy: '复制',
  luoleAdmin_jobFair_delete_confirm: '确定要删除这个招聘会吗？',
  luoleAdmin_jobFair_delete_success: '删除成功',
  luoleAdmin_jobFair_delete_failed: '删除失败',
  luoleAdmin_jobFair_update_success: '更新成功',
  luoleAdmin_jobFair_create_success: '创建成功',
  luoleAdmin_jobFair_save_failed: '保存失败',
  luoleAdmin_jobFair_save_draft: '保存草稿',
  luoleAdmin_jobFair_save_draft_success: '草稿保存成功',
  luoleAdmin_jobFair_publish: '发布',
  luoleAdmin_jobFair_column_name: '招聘会名称',
  luoleAdmin_jobFair_column_time: '时间',
  luoleAdmin_jobFair_column_location: '地点',
  luoleAdmin_jobFair_column_status: '状态',
  luoleAdmin_jobFair_column_enterprises: '参与企业',
  luoleAdmin_jobFair_column_talents: '参与人才',
  luoleAdmin_jobFair_column_created: '创建时间',
  luoleAdmin_jobFair_column_cover: '封面图',
  luoleAdmin_jobFair_view_table: '表格',
  luoleAdmin_jobFair_view_card: '卡片',
  luoleAdmin_jobFair_no_cover: '无封面',
  luoleAdmin_jobFair_pagination_total: '共 {total} 条，显示 {start}-{end} 条',
  luoleAdmin_jobFair_modal_create: '创建招聘会',
  luoleAdmin_jobFair_modal_edit: '编辑招聘会',
  luoleAdmin_jobFair_form_page_description_create:
    '填写招聘会基本信息、时间地点与组织方信息。',
  luoleAdmin_jobFair_form_page_description_edit: '修改招聘会信息与配置。',
  luoleAdmin_jobFair_form_required: '此字段为必填项。',
  luoleAdmin_jobFair_form_name: '招聘会名称',
  luoleAdmin_jobFair_form_name_placeholder: '请输入招聘会名称',
  luoleAdmin_jobFair_form_theme: '主题',
  luoleAdmin_jobFair_form_theme_placeholder:
    '请输入主题（如：IT、金融、医疗等）',
  luoleAdmin_jobFair_form_description: '描述',
  luoleAdmin_jobFair_form_description_placeholder: '请输入描述',
  luoleAdmin_jobFair_form_startDate: '开始日期',
  luoleAdmin_jobFair_form_endDate: '结束日期',
  luoleAdmin_jobFair_form_startTime: '开始时间',
  luoleAdmin_jobFair_form_endTime: '结束时间',
  luoleAdmin_jobFair_form_location: '地点',
  luoleAdmin_jobFair_form_location_placeholder: '请输入地点',
  luoleAdmin_jobFair_form_maxParticipants: '最大参与人数',
  luoleAdmin_jobFair_form_maxParticipants_placeholder: '请输入最大参与人数',
  luoleAdmin_jobFair_form_maxEnterprises: '企业上限',
  luoleAdmin_jobFair_form_maxEnterprises_placeholder: '请输入企业上限',
  luoleAdmin_jobFair_form_maxJobs: '职位上限',
  luoleAdmin_jobFair_form_maxJobs_placeholder: '请输入职位上限',
  luoleAdmin_jobFair_form_organizer: '主办方',
  luoleAdmin_jobFair_form_organizer_placeholder: '请输入主办方',
  luoleAdmin_jobFair_form_contact: '联系人',
  luoleAdmin_jobFair_form_contact_placeholder: '请输入联系人',
  luoleAdmin_jobFair_form_phone: '联系电话',
  luoleAdmin_jobFair_form_phone_placeholder: '请输入联系电话',
  luoleAdmin_jobFair_form_email: '邮箱',
  luoleAdmin_jobFair_form_email_placeholder: '请输入邮箱',
  luoleAdmin_jobFair_form_email_invalid: '请输入有效的邮箱地址。',
  luoleAdmin_jobFair_form_bannerImage: '主横幅图片',
  luoleAdmin_jobFair_form_coverImage: '封面图',
  luoleAdmin_jobFair_form_coverImage_upload: '上传封面图',
  luoleAdmin_jobFair_form_coverImage_hint: '推荐尺寸：1920x600px，最大 15MB',
  luoleAdmin_jobFair_form_group_basic: '基本信息',
  luoleAdmin_jobFair_form_group_timeLocation: '时间与地点',
  luoleAdmin_jobFair_form_group_scale: '规模设置',
  luoleAdmin_jobFair_form_group_organizer: '组织者信息',
  luoleAdmin_jobFair_form_group_status: '状态与封面',
  luoleAdmin_jobFair_form_showOnHomepage: '显示在首页',
  luoleAdmin_jobFair_detail_tab_basic: '基本信息',
  luoleAdmin_jobFair_detail_tab_enterprises: '企业列表',
  luoleAdmin_jobFair_detail_tab_jobs: '职位列表',
  luoleAdmin_jobFair_detail_tab_liveStreams: '直播管理',
  luoleAdmin_jobFair_detail_tab_statistics: '数据统计',
  luoleAdmin_jobFair_detail_tab_infoFlow: '信息发布',
  luoleAdmin_jobFair_infoFlow_config_title: '信息发布',
  luoleAdmin_jobFair_infoFlow_add: '添加内容',
  luoleAdmin_jobFair_infoFlow_edit: '编辑内容',
  luoleAdmin_jobFair_infoFlow_add_modal: '添加信息发布',
  luoleAdmin_jobFair_infoFlow_add_success: '添加成功',
  luoleAdmin_jobFair_infoFlow_edit_success: '更新成功',
  luoleAdmin_jobFair_infoFlow_delete_success: '删除成功',
  luoleAdmin_jobFair_infoFlow_load_failed: '加载信息发布列表失败',
  luoleAdmin_jobFair_infoFlow_delete_failed: '删除失败',
  luoleAdmin_jobFair_infoFlow_type_goodNews: '喜报',
  luoleAdmin_jobFair_infoFlow_type_announcement: '公告',
  luoleAdmin_jobFair_infoFlow_type_dynamic: '动态',
  luoleAdmin_jobFair_infoFlow_format_text: '文本',
  luoleAdmin_jobFair_infoFlow_format_richtext: '富文本',
  luoleAdmin_jobFair_infoFlow_format_image: '图片',
  luoleAdmin_jobFair_infoFlow_format_link: '链接',
  luoleAdmin_jobFair_infoFlow_column_sortOrder: '排序',
  luoleAdmin_jobFair_infoFlow_column_contentType: '内容类型',
  luoleAdmin_jobFair_infoFlow_column_format: '内容格式',
  luoleAdmin_jobFair_infoFlow_column_title: '标题',
  luoleAdmin_jobFair_infoFlow_column_content: '内容',
  luoleAdmin_jobFair_infoFlow_column_status: '状态',
  luoleAdmin_jobFair_infoFlow_status_draft: '草稿',
  luoleAdmin_jobFair_infoFlow_status_published: '已发布',
  luoleAdmin_jobFair_infoFlow_carousel_enabled: '自动轮播',
  luoleAdmin_jobFair_infoFlow_carousel_interval: '轮播间隔',
  luoleAdmin_jobFair_infoFlow_carousel_seconds: '秒',
  luoleAdmin_jobFair_infoFlow_carousel_mode: '轮播方式',
  luoleAdmin_jobFair_infoFlow_linkUrl: '链接地址',
  luoleAdmin_jobFair_infoFlow_linkUrl_invalid: '请输入有效的链接地址',
  luoleAdmin_jobFair_infoFlow_imageUrl: '图片地址',
  luoleAdmin_jobFair_infoFlow_title_placeholder: '标题',
  luoleAdmin_jobFair_infoFlow_content_placeholder: '内容文本',
  luoleAdmin_jobFair_goodNews_title: '喜报管理',
  luoleAdmin_jobFair_goodNews_add: '添加喜报',
  luoleAdmin_jobFair_goodNews_edit: '编辑喜报',
  luoleAdmin_jobFair_goodNews_add_modal: '添加喜报',
  luoleAdmin_jobFair_goodNews_add_success: '添加成功',
  luoleAdmin_jobFair_goodNews_edit_success: '更新成功',
  luoleAdmin_jobFair_goodNews_delete_success: '删除成功',
  luoleAdmin_jobFair_goodNews_column_title: '标题',
  luoleAdmin_jobFair_goodNews_column_source: '来源',
  luoleAdmin_jobFair_goodNews_column_audit: '审核状态',
  luoleAdmin_jobFair_goodNews_column_verified: '数据校验',
  luoleAdmin_jobFair_goodNews_column_fakeWarning: '可造假标注',
  luoleAdmin_jobFair_goodNews_source_manual: '手动添加',
  luoleAdmin_jobFair_goodNews_source_auto: '自动生成',
  luoleAdmin_jobFair_goodNews_audit_pending: '待审核',
  luoleAdmin_jobFair_goodNews_audit_approved_label: '已通过',
  luoleAdmin_jobFair_goodNews_audit_rejected_label: '已拒绝',
  luoleAdmin_jobFair_goodNews_audit_approve: '通过',
  luoleAdmin_jobFair_goodNews_audit_reject: '拒绝',
  luoleAdmin_jobFair_goodNews_audit_approved: '已通过',
  luoleAdmin_jobFair_goodNews_audit_rejected: '已拒绝',
  luoleAdmin_jobFair_goodNews_verified: '已校验',
  luoleAdmin_jobFair_goodNews_not_verified: '未校验',
  luoleAdmin_jobFair_goodNews_fake_warning: '可造假提醒',
  luoleAdmin_jobFair_goodNews_fake_warning_hint:
    '开启后，该条喜报将标注「数据可造假」用于展示提醒。',
  luoleAdmin_jobFair_goodNews_data_notice:
    '确保数据真实性。可为喜报标注「可造假」提醒，便于对外透明说明。',
  luoleAdmin_jobFair_goodNews_title_placeholder:
    '如：XX 企业成功招聘 10 名人才',
  luoleAdmin_jobFair_goodNews_content_placeholder: '喜报内容',
  luoleAdmin_messageManagement_title: '留言管理',
  luoleAdmin_messageManagement_description: '处理企业与人才的反馈与咨询。',
  luoleAdmin_dictionaryManagement_title: '职位类别',
  luoleAdmin_dictionaryManagement_description:
    '维护职位分类层级，与前端展示保持一致。',
  luoleAdmin_dictionaryManagement_stat_total: '总类别数',
  luoleAdmin_dictionaryManagement_stat_active: '启用中',
  luoleAdmin_dictionaryManagement_stat_inactive: '已停用',
  luoleAdmin_dictionaryManagement_stat_level1: '一级分类',
  luoleAdmin_dictionaryManagement_tree_title: '职位类别树',
  luoleAdmin_dictionaryManagement_search_placeholder: '搜索类别名称或代码',
  luoleAdmin_dictionaryManagement_status_all: '全部状态',
  luoleAdmin_dictionaryManagement_status_active: '启用',
  luoleAdmin_dictionaryManagement_status_inactive: '停用',
  luoleAdmin_dictionaryManagement_add: '添加类别',
  luoleAdmin_dictionaryManagement_batch_delete: '批量删除 ({{count}})',
  luoleAdmin_dictionaryManagement_table_total:
    '第 {start}-{end} 条 / 共 {total} 条',
  luoleAdmin_dictionaryManagement_column_name: '类别名称',
  luoleAdmin_dictionaryManagement_column_value: '类别值',
  luoleAdmin_dictionaryManagement_column_description: '描述',
  luoleAdmin_dictionaryManagement_column_level: '层级',
  luoleAdmin_dictionaryManagement_column_sort: '排序',
  luoleAdmin_dictionaryManagement_column_status: '状态',
  luoleAdmin_dictionaryManagement_column_createdAt: '创建时间',
  luoleAdmin_dictionaryManagement_column_actions: '操作',
  luoleAdmin_dictionaryManagement_level_label: '第 {{level}} 级',
  luoleAdmin_dictionaryManagement_modal_create: '添加类别',
  luoleAdmin_dictionaryManagement_modal_edit: '编辑类别',
  luoleAdmin_dictionaryManagement_form_name: '类别名称',
  luoleAdmin_dictionaryManagement_form_name_placeholder: '请输入类别名称',
  luoleAdmin_dictionaryManagement_form_code: '类别代码',
  luoleAdmin_dictionaryManagement_form_code_placeholder: '请输入类别代码',
  luoleAdmin_dictionaryManagement_form_value: '类别值',
  luoleAdmin_dictionaryManagement_form_value_placeholder: '请输入类别值',
  luoleAdmin_dictionaryManagement_form_description: '描述',
  luoleAdmin_dictionaryManagement_form_description_placeholder: '请输入描述',
  luoleAdmin_dictionaryManagement_form_parent: '父级类别',
  luoleAdmin_dictionaryManagement_form_parent_placeholder:
    '请选择父级类别（可选）',
  luoleAdmin_dictionaryManagement_form_sort: '排序',
  luoleAdmin_dictionaryManagement_form_status: '状态',
  luoleAdmin_dictionaryManagement_form_status_placeholder: '请选择状态',
  luoleAdmin_dictionaryManagement_form_required: '该字段为必填项。',
  luoleAdmin_dictionaryManagement_load_failed: '加载职位类别失败。',
  luoleAdmin_dictionaryManagement_action_failed: '操作失败，请稍后重试。',
  luoleAdmin_dictionaryManagement_delete_success: '类别已删除。',
  luoleAdmin_dictionaryManagement_batch_delete_success:
    '成功删除 {{count}} 个类别。',
  luoleAdmin_dictionaryManagement_enable_success: '类别已启用。',
  luoleAdmin_dictionaryManagement_disable_success: '类别已停用。',
  luoleAdmin_dictionaryManagement_create_success: '类别创建成功。',
  luoleAdmin_dictionaryManagement_update_success: '类别更新成功。',
  luoleAdmin_dictionaryManagement_add_primary: '添加一级分类',
  luoleAdmin_dictionaryManagement_add_under: '添加子项',
  luoleAdmin_dictionaryManagement_add_item: '添加项',
  luoleAdmin_dictionaryManagement_add_first: '添加首项',
  luoleAdmin_dictionaryManagement_enable: '启用',
  luoleAdmin_dictionaryManagement_disable: '停用',
  luoleAdmin_dictionaryManagement_select_category: '请选择左侧分类',
  luoleAdmin_dictionaryManagement_empty_primary: '暂无一级分类，请先添加',
  luoleAdmin_dictionaryManagement_empty_items: '该分类下暂无子项，',
  luoleAdmin_dictionaryManagement_move_up: '上移',
  luoleAdmin_dictionaryManagement_move_down: '下移',
  luoleAdmin_dictionaryManagement_sort_success: '排序已更新',
  luoleAdmin_dictionaryManagement_delete_confirm: '确认删除',
  luoleAdmin_dictionaryManagement_delete_confirm_content:
    '确定要删除「{{name}}」吗？此操作不可恢复。',
  luoleAdmin_jobCategoriesManagement_title: '职位类别管理',
  luoleAdmin_jobCategoriesManagement_description: '维护职位分类层级。',
  luoleAdmin_jobCategoriesManagement_stat_total: '总类别数',
  luoleAdmin_jobCategoriesManagement_stat_active: '启用中',
  luoleAdmin_jobCategoriesManagement_stat_inactive: '已停用',
  luoleAdmin_jobCategoriesManagement_stat_jobs: '总职位数',
  luoleAdmin_jobCategoriesManagement_tree_title: '类别树',
  luoleAdmin_jobCategoriesManagement_search_placeholder: '搜索类别名称',
  luoleAdmin_jobCategoriesManagement_status_all: '全部状态',
  luoleAdmin_jobCategoriesManagement_status_active: '启用',
  luoleAdmin_jobCategoriesManagement_status_inactive: '停用',
  luoleAdmin_jobCategoriesManagement_add: '添加类别',
  luoleAdmin_jobCategoriesManagement_add_root: '添加一级类别',
  luoleAdmin_jobCategoriesManagement_batch_delete: '批量删除 ({{count}})',
  luoleAdmin_jobCategoriesManagement_table_total:
    '第 {start}-{end} 条 / 共 {total} 条',
  luoleAdmin_jobCategoriesManagement_column_name: '类别信息',
  luoleAdmin_jobCategoriesManagement_column_level: '层级',
  luoleAdmin_jobCategoriesManagement_level_root: '顶级',
  luoleAdmin_jobCategoriesManagement_level_child: '子级',
  luoleAdmin_jobCategoriesManagement_parent_root: '顶级',
  luoleAdmin_jobCategoriesManagement_column_parent: '父级',
  luoleAdmin_jobCategoriesManagement_column_sort: '排序',
  luoleAdmin_jobCategoriesManagement_column_status: '状态',
  luoleAdmin_jobCategoriesManagement_column_createdAt: '创建时间',
  luoleAdmin_jobCategoriesManagement_column_actions: '操作',
  luoleAdmin_jobCategoriesManagement_modal_create: '添加类别',
  luoleAdmin_jobCategoriesManagement_modal_edit: '编辑类别',
  luoleAdmin_jobCategoriesManagement_form_title: '类别名称',
  luoleAdmin_jobCategoriesManagement_form_title_placeholder: '请输入类别名称',
  luoleAdmin_jobCategoriesManagement_form_parent: '父级类别',
  luoleAdmin_jobCategoriesManagement_form_parent_placeholder:
    '请选择父级类别（可选）',
  luoleAdmin_jobCategoriesManagement_form_sort: '排序',
  luoleAdmin_jobCategoriesManagement_form_status: '状态',
  luoleAdmin_jobCategoriesManagement_form_status_placeholder: '请选择状态',
  luoleAdmin_jobCategoriesManagement_form_required: '该字段为必填项。',
  luoleAdmin_jobCategoriesManagement_load_failed: '加载类别数据失败。',
  luoleAdmin_jobCategoriesManagement_action_failed: '操作失败，请稍后重试。',
  luoleAdmin_jobCategoriesManagement_delete_confirm: '确认删除',
  luoleAdmin_jobCategoriesManagement_delete_success: '类别已删除。',
  luoleAdmin_jobCategoriesManagement_batch_delete_success:
    '成功删除 {{count}} 个类别。',
  luoleAdmin_jobCategoriesManagement_enable_success: '类别已启用。',
  luoleAdmin_jobCategoriesManagement_disable_success: '类别已停用。',
  luoleAdmin_jobCategoriesManagement_create_success: '类别创建成功。',
  luoleAdmin_jobCategoriesManagement_update_success: '类别更新成功。',
  luoleAdmin_jobCategoriesManagement_enable: '启用',
  luoleAdmin_jobCategoriesManagement_disable: '停用',
  luoleAdmin_jobCategoriesManagement_add_child: '添加子类别',
  luoleAdmin_jobCategoriesManagement_detail_title: '类别详情 - {{name}}',
  luoleAdmin_jobCategoriesManagement_detail_title_default: '类别详情',
  luoleAdmin_jobCategoriesManagement_detail_load_failed: '加载类别详情失败',
  luoleAdmin_jobCategoriesManagement_detail_select_first:
    '请先选择要操作的类别',
  luoleAdmin_jobCategoriesManagement_detail_invalid_id:
    '类别ID无效，请刷新页面后重试',
  luoleAdmin_jobCategoriesManagement_detail_jobCount: '岗位数量',
  luoleAdmin_jobCategoriesManagement_detail_childCount: '子类别数量',
  luoleAdmin_jobCategoriesManagement_detail_status: '状态',
  luoleAdmin_jobCategoriesManagement_detail_attributes: '类别属性',
  luoleAdmin_jobCategoriesManagement_detail_id: '类别ID',
  luoleAdmin_jobCategoriesManagement_detail_code: '类别代码',
  luoleAdmin_jobCategoriesManagement_detail_level: '层级',
  luoleAdmin_jobCategoriesManagement_detail_sort: '排序',
  luoleAdmin_jobCategoriesManagement_detail_parent: '父级类别',
  luoleAdmin_jobCategoriesManagement_detail_createdAt: '创建时间',
  luoleAdmin_jobCategoriesManagement_detail_updatedAt: '更新时间',
  luoleAdmin_jobCategoriesManagement_detail_children: '子类别列表',
  luoleAdmin_jobCategoriesManagement_detail_jobs: '个岗位',
  luoleAdmin_jobCategoriesManagement_detail_select_hint:
    '请在左侧选择类别查看详情',
  luoleAdmin_jobCategoriesManagement_level_1: '一级',
  luoleAdmin_jobCategoriesManagement_level_2: '二级',
  luoleAdmin_jobCategoriesManagement_level_3: '三级',
  luoleAdmin_jobCategoriesManagement_level_other: '{{level}}级',
  luoleAdmin_jobCategoriesManagement_confirm_action: '确认{{action}}',
  luoleAdmin_jobCategoriesManagement_confirm_action_content:
    '确定要{{action}}类别"{{name}}"吗？',
  luoleAdmin_jobCategoriesManagement_status_updated: '职位类别已{{action}}',
  luoleAdmin_jobCategoriesManagement_delete_confirm_content:
    '确定要删除类别"{{name}}"吗？此操作不可恢复。',
  luoleAdmin_jobCategoriesManagement_form_parent_hint:
    '将在"{{name}}"下添加子类别',
  luoleAdmin_jobCategoriesManagement_unknown_category: '未知类别',
  luoleAdmin_common_loading: '加载中...',
  luoleAdmin_resumeTemplateManagement_title: '简历模版',
  luoleAdmin_resumeTemplateManagement_description:
    '管理简历模版，用于列表展示与导出。',
  luoleAdmin_resumeTemplateManagement_stat_total: '模版总数',
  luoleAdmin_resumeTemplateManagement_stat_free: '免费',
  luoleAdmin_resumeTemplateManagement_stat_featured: '精选',
  luoleAdmin_resumeTemplateManagement_search_placeholder: '搜索模版名称',
  luoleAdmin_resumeTemplateManagement_category_all: '全部分类',
  luoleAdmin_resumeTemplateManagement_category_free: '免费',
  luoleAdmin_resumeTemplateManagement_category_featured: '精选',
  luoleAdmin_resumeTemplateManagement_isFree_all: '全部',
  luoleAdmin_resumeTemplateManagement_isFree_free: '免费',
  luoleAdmin_resumeTemplateManagement_isFree_locked: '待解锁',
  luoleAdmin_resumeTemplateManagement_add: '添加模版',
  luoleAdmin_resumeTemplateManagement_column_name: '模版名称',
  luoleAdmin_resumeTemplateManagement_column_thumbnail: '缩略图',
  luoleAdmin_resumeTemplateManagement_column_category: '分类',
  luoleAdmin_resumeTemplateManagement_column_isFree: '免费',
  luoleAdmin_resumeTemplateManagement_column_sortOrder: '排序',
  luoleAdmin_resumeTemplateManagement_column_createdAt: '创建时间',
  luoleAdmin_resumeTemplateManagement_column_actions: '操作',
  luoleAdmin_resumeTemplateManagement_modal_create: '添加模版',
  luoleAdmin_resumeTemplateManagement_modal_edit: '编辑模版',
  luoleAdmin_resumeTemplateManagement_form_name: '模版名称',
  luoleAdmin_resumeTemplateManagement_form_name_placeholder: '请输入模版名称',
  luoleAdmin_resumeTemplateManagement_form_thumbnailUrl: '缩略图地址',
  luoleAdmin_resumeTemplateManagement_form_thumbnailUrl_placeholder:
    '请输入缩略图 URL',
  luoleAdmin_resumeTemplateManagement_form_templateUrl: '模版地址',
  luoleAdmin_resumeTemplateManagement_form_templateUrl_placeholder:
    '请输入模版文件或模版 ID 地址',
  luoleAdmin_resumeTemplateManagement_form_tags: '标签',
  luoleAdmin_resumeTemplateManagement_form_tags_placeholder:
    '逗号分隔，如：简约,商务',
  luoleAdmin_resumeTemplateManagement_form_isFree: '是否免费',
  luoleAdmin_resumeTemplateManagement_form_category: '分类',
  luoleAdmin_resumeTemplateManagement_form_sortOrder: '排序',
  luoleAdmin_resumeTemplateManagement_form_required: '该字段为必填项。',
  luoleAdmin_resumeTemplateManagement_upload_thumbnail: '上传缩略图',
  luoleAdmin_resumeTemplateManagement_upload_template: '上传模版文件',
  luoleAdmin_resumeTemplateManagement_or_enter_url: '或输入地址',
  luoleAdmin_resumeTemplateManagement_uploading: '上传中...',
  luoleAdmin_resumeTemplateManagement_load_failed: '加载模版列表失败。',
  luoleAdmin_resumeTemplateManagement_action_failed: '操作失败，请重试。',
  luoleAdmin_resumeTemplateManagement_delete_confirm: '确认删除该模版？',
  luoleAdmin_resumeTemplateManagement_delete_success: '模版已删除。',
  luoleAdmin_resumeTemplateManagement_batch_delete_success:
    '已删除 {{count}} 个模版。',
  luoleAdmin_resumeTemplateManagement_create_success: '模版创建成功。',
  luoleAdmin_resumeTemplateManagement_update_success: '模版更新成功。',
  luoleAdmin_talentRecommendation_title: '人才推荐',
  luoleAdmin_talentRecommendation_description: '根据发布的职位推荐匹配的人才',
  luoleAdmin_talentRecommendation_select_job: '选择职位',
  luoleAdmin_talentRecommendation_select_job_placeholder: '请选择职位',
  luoleAdmin_talentRecommendation_select_job_first: '请先选择职位',
  luoleAdmin_talentRecommendation_min_match_score: '最低匹配度',
  luoleAdmin_talentRecommendation_filter_all: '全部',
  luoleAdmin_talentRecommendation_generate: '生成推荐',
  luoleAdmin_talentRecommendation_load_jobs_failed: '加载职位列表失败',
  luoleAdmin_talentRecommendation_load_failed: '加载推荐列表失败',
  luoleAdmin_talentRecommendation_generate_success: '推荐生成成功',
  luoleAdmin_talentRecommendation_generate_failed: '推荐生成失败',
  luoleAdmin_talentRecommendation_detail_failed: '加载人才详情失败',
  luoleAdmin_talentRecommendation_empty: '暂无推荐数据',
  luoleAdmin_talentRecommendation_column_rank: '排名',
  luoleAdmin_talentRecommendation_column_talent: '人才信息',
  luoleAdmin_talentRecommendation_column_matchScore: '匹配度',
  luoleAdmin_talentRecommendation_column_matchReasons: '匹配原因',
  luoleAdmin_talentRecommendation_column_job: '推荐职位',
  luoleAdmin_talentRecommendation_match_excellent: '优秀',
  luoleAdmin_talentRecommendation_match_good: '良好',
  luoleAdmin_talentRecommendation_match_fair: '一般',
  luoleAdmin_talentRecommendation_match_poor: '较差',
  luoleAdmin_talentRecommendation_job_title: '职位名称',
  luoleAdmin_talentRecommendation_job_location: '工作地点',
  luoleAdmin_talentRecommendation_job_category: '职位类别',
  luoleAdmin_talentRecommendation_job_type: '职位类型',
  luoleAdmin_talentRecommendation_stat_total: '推荐总数',
  luoleAdmin_talentRecommendation_stat_avg_match_score: '平均匹配度',
  luoleAdmin_talentRecommendation_stat_excellent: '优秀匹配',
  luoleAdmin_talentRecommendation_stat_good: '良好匹配',
  luoleAdmin_talentRecommendation_detail_title: '人才详情',
  luoleAdmin_talentRecommendation_detail_name: '姓名',
  luoleAdmin_talentRecommendation_detail_email: '邮箱',
  luoleAdmin_talentRecommendation_detail_phone: '电话',
  luoleAdmin_talentRecommendation_detail_position: '职位',
  luoleAdmin_talentRecommendation_detail_status: '状态',
  luoleAdmin_talentRecommendation_detail_bio: '个人简介',
  luoleAdmin_talentRecommendation_detail_created: '创建时间',
  luoleAdmin_talentRecommendation_pagination_total:
    '第 {start}-{end} 条 / 共 {total} 条',
  luoleAdmin_common_unknown: '未知',
  talents_cancel: '取消',
  talents_action_save: '保存',
  talents_modal_add_title: '新增人才',
  talents_modal_edit_title: '编辑人才',
  talents_import_title: '上传简历',
  talents_import_file_label: '简历文件',
  talents_import_file_hint: '点击上传简历',
  talents_import_file_support: '支持 PDF、DOC、DOCX 格式，文件大小不超过 10MB',
  talents_import_parse_info: '简历解析成功，已填充到表单',
  talents_import_failed: '上传简历失败',
  talents_save_failed: '保存人才失败',
  talents_basic_info: '基础信息',
  talents_status_active: '在库',
  talents_status_inactive: '无效',
  talents_status_placed: '已推荐/已入职',
  talents_status_blacklisted: '黑名单',
  talents_field_avatar_upload: '上传头像',
  talents_field_avatar_uploading: '头像上传中...',
  talents_field_name: '姓名',
  talents_field_name_required: '请输入姓名',
  talents_field_name_placeholder: '请输入姓名',
  talents_field_gender: '性别',
  talents_field_gender_male: '男',
  talents_field_gender_female: '女',
  talents_field_gender_placeholder: '请选择性别',
  talents_field_status: '人才状态',
  talents_field_status_placeholder: '请选择人才状态',
  talents_field_age: '年龄',
  talents_field_age_placeholder: '请输入年龄',
  talents_field_birthdate: '出生日期',
  talents_field_education: '最高学历',
  talents_field_education_placeholder: '请选择学历',
  talents_field_phone: '手机号',
  talents_field_phone_placeholder: '请输入手机号',
  talents_field_email: '邮箱',
  talents_field_email_placeholder: '请输入邮箱',
  talents_field_wechat: '微信号',
  talents_field_current_company: '目前公司',
  talents_field_current_company_placeholder: '请输入目前就职公司',
  talents_field_current_position: '目前职位',
  talents_field_current_position_placeholder: '请输入目前职位',
  talents_field_current_salary: '目前薪资（元/月）',
  talents_field_current_salary_placeholder: '请输入目前薪资',
  talents_field_work_experience: '工作年限',
  talents_field_work_experience_placeholder: '请输入工作年限',
  talents_field_source: '来源渠道',
  talents_field_location: '目前城市',
  talents_field_location_placeholder: '请输入目前城市',
  talents_field_tags: '标签',
  talents_field_tags_placeholder: '输入后回车可添加标签',
  talents_field_notes: '备注',
  talents_field_notes_placeholder: '请输入备注信息',
  talents_work_history: '工作经历',
  talents_project_experience: '项目经历',
  talents_education_experience: '教育经历',
  talents_field_company: '公司名称',
  talents_field_department: '部门',
  talents_field_position: '职位',
  talents_field_start_date: '开始时间',
  talents_field_end_date: '结束时间',
  talents_field_is_current: '目前在职',
  talents_field_description: '详细描述',
  talents_add_work_history: '新增工作经历',
  talents_add_project: '新增项目经历',
  talents_add_education: '新增教育经历',
  talents_remove: '删除',
  luoleAdmin_messageManagement_search_placeholder: '搜索留言主题或发送人',
  luoleAdmin_messageManagement_status_all: '全部状态',
  luoleAdmin_messageManagement_status_unread: '未读',
  luoleAdmin_messageManagement_status_read: '已读',
  luoleAdmin_messageManagement_status_replied: '已回复',
  luoleAdmin_messageManagement_type_all: '全部类型',
  luoleAdmin_messageManagement_type_candidate: '候选人',
  luoleAdmin_messageManagement_type_enterprise: '企业',
  luoleAdmin_messageManagement_type_hunter: '猎头',
  luoleAdmin_messageManagement_column_sender: '发送人',
  luoleAdmin_messageManagement_column_subject: '主题',
  luoleAdmin_messageManagement_column_status: '状态',
  luoleAdmin_messageManagement_column_time: '时间',
  luoleAdmin_messageManagement_reply_placeholder: '请输入回复内容',
  luoleAdmin_messageManagement_reply_action: '回复',
  luoleAdmin_messageManagement_load_failed: '留言加载失败',
  luoleAdmin_messageManagement_reply_success: '回复成功',
  luoleAdmin_messageManagement_reply_failed: '回复失败',
  luoleAdmin_messageManagement_delete_success: '删除成功',
  luoleAdmin_messageManagement_delete_failed: '删除失败',
  luoleAdmin_messageManagement_delete_confirm: '确认删除这条留言吗？',
};
